import React, { Component, createElement } from "react";
import { WithPermissions } from "react-admin";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classnames from "classnames";
import {
  MuiThemeProvider,
  createMuiTheme,
  withStyles
} from "@material-ui/core/styles";
import compose from "recompose/compose";

import AppBar from "ra-ui-materialui/lib/layout/AppBar";
import Sidebar from "ra-ui-materialui/lib/layout/Sidebar";
import Menu from "./Menu";
import Notification from "ra-ui-materialui/lib/layout/Notification";
import indigo from "@material-ui/core/colors/indigo";
import red from "@material-ui/core/colors/red";

const customTheme = createMuiTheme({
  palette: {
    primary: indigo,
    secondary: (process.env.REACT_APP_PRODUCTION==='true') ? indigo : red,
    error: red,
    contrastThreshold: 3,
    tonalOffset: 0.2,
    background: {
      paper: "#fff",
      default: "#f6f6f6"
    }
  },
  typography: {
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Arial",
      "sans-serif"
    ].join(",")
  },
  overrides: {
    MuiButton: {
      // override the styles of all instances of this component
      root: {
        // Name of the rule
      }
    },
    MuiList: {
      root: {}
    },
    MuiListItem: {
      root: {
        borderRadius: "15px 15px 15px 15px"
      }
    },
    MuiCard: {
      root: {
        border: "1px solid #e4e4e4",
        backgroundColor: "#fff",

      }
    },
    MuiPaper: {
      root: {}
    },
    SaveButton: {}
  }
});

const styles = theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    zIndex: 1,
    minHeight: "100vh",
    backgroundColor: theme.palette.background.default,
    position: "relative"
  },
  appFrame: {
    display: "flex",
    flexDirection: "column",
    overflowX: "auto"
  },
  contentWithSidebar: {
    display: "flex",
    flexGrow: 1
  },
  content: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 2,
    padding: theme.spacing.unit * 3,
    [theme.breakpoints.up("xs")]: {
      paddingLeft: 5
    },
    [theme.breakpoints.down("sm")]: {
      padding: 0
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "3em"
    }
  }
});

const sanitizeRestProps = ({ staticContext, ...props }) => props;

const hasPermissions = permission => {
  const permissions = [
    "admin",
    "coordinador",
    "cartonero",
    "pesador",
    "auditor",
    "enfardador"
  ];
  return permissions.indexOf(permission) > -1;
};

const Layout = ({
  appBar,
  children,
  classes,
  className,
  customRoutes,
  dashboard,
  logout,
  menu,
  notification,
  open,
  title,
  ...props
}) => (
  <WithPermissions
    render={({ permissions }) => {
      return (
        <div
          className={classnames("layout", classes.root, className)}
          {...sanitizeRestProps(props)}
        >
          <div className={classes.appFrame}>
            {createElement(appBar, { title, open, logout })}
            <main className={classes.contentWithSidebar}>
              {hasPermissions(permissions) && (
                <Sidebar>
                  {createElement(menu, {
                    logout,
                    hasDashboard: !!dashboard
                  })}
                </Sidebar>
              )}
              <div className={classes.content}>{children}</div>
            </main>
            {createElement(notification)}
          </div>
        </div>
      );
    }}
  />
);

const componentPropType = PropTypes.oneOfType([
  PropTypes.func,
  PropTypes.string
]);

Layout.propTypes = {
  appBar: componentPropType,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  classes: PropTypes.object,
  className: PropTypes.string,
  customRoutes: PropTypes.array,
  dashboard: componentPropType,
  logout: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
    PropTypes.string
  ]),
  menu: componentPropType,
  notification: componentPropType,
  open: PropTypes.bool,
  title: PropTypes.node.isRequired
};

Layout.defaultProps = {
  appBar: AppBar,
  menu: Menu,
  notification: Notification
};

const mapStateToProps = state => ({
  open: state.admin.ui.sidebarOpen
});

const EnhancedLayout = compose(
  connect(
    mapStateToProps,
    {} // Avoid connect passing dispatch in props
  ),
  withStyles(styles)
)(Layout);

class LayoutWithTheme extends Component {
  constructor(props) {
    super(props);
    this.theme = createMuiTheme(props.theme);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.theme !== this.props.theme) {
      this.theme = createMuiTheme(nextProps.theme);
    }
  }
  render() {
    const { theme, ...rest } = this.props;
    return (
      <MuiThemeProvider theme={theme}>
        <EnhancedLayout {...rest} />
      </MuiThemeProvider>
    );
  }
}

LayoutWithTheme.propTypes = {
  theme: PropTypes.object
};

LayoutWithTheme.defaultProps = {
  theme: customTheme
};

export default LayoutWithTheme;



// WEBPACK FOOTER //
// ./src/layout/Layout.js